module.exports = __webpack_public_path__ + "images/icon_maintanance_64b9516ca25a5b5e1a47fbd8b62f5763.svg";